// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 1024px) {\n.map-title .information-container .information-tooltip {\n    min-width: 25vw;\n}\n}\n@media (max-width: 600px) {\n.map-title .information-container .information-tooltip {\n    min-width: calc(100% + 215px);\n}\n}", ""]);
// Exports
module.exports = exports;
